import "./Spinner.scss";


const DataSpinner = () => {
    return (
        <div className="fallback-elements">
            <div className="spin">
            </div>
        </div>

    )

}

export default DataSpinner; 
